import { useState, useEffect } from "react";
import { InputField } from "../common";
import { toast } from "react-toastify";
import { gql, useMutation } from "@apollo/client";

interface RateEditorProps {
  rate: number;
  rate_id: number;
  onSave?: () => void; // Optional callback for after save action
};

const UPDATE_EXCHANGE_RATE = gql`
  mutation UpdateExchangeRate($id: ID!, $input: CurrencyExchangeUpdateInput!) {
    updateExchangeRate(id: $id, input: $input) {
      currencyExchange {
        id
        exchangeRate
        lastModified
        targetCurrency
        baseCurrency
      }
    }
  }
`;

function RateEditor({ rate, rate_id, onSave }: RateEditorProps) {
  const [editedQuantity, setEditedQuantity] = useState(rate);
  const [isChanged, setIsChanged] = useState(false);

  useEffect(() => {
    // Reset isChanged if editedQuantity matches the initial quantity
    setIsChanged(editedQuantity !== rate);
  }, [editedQuantity, rate]);

  const [updateExchangeRate, { loading, error }] = useMutation(UPDATE_EXCHANGE_RATE, {
    onCompleted: (data) => {
      toast.success("Exchange rate updated successfully!");
      if (onSave) {
        onSave();
      }
    },
    onError: (error) => {
      toast.error(`Failed to update exchange rate: ${error.message}`);
    },
  });

  const handleSave = (e: any) => {
    e.preventDefault();
    const payload = {
        id: rate_id,
        input: {
          exchangeRate: editedQuantity,
        },
    };
    updateExchangeRate({ variables: payload });  
    
  };

  return (
    <div className="flex items-center gap-2">
      <InputField
        className="border-3"
        type="number"
        value={editedQuantity}
        onChange={(e) => setEditedQuantity(Number(e.target.value))}
      />
      <button
        className={`px-2 py-1 rounded ${isChanged ? "bg-primary-500 text-white" : "bg-gray-300 text-gray-500 cursor-not-allowed"}`}
        onClick={handleSave}
        disabled={!isChanged} // Disable button if no changes
      >
        Save
      </button>
    </div>
  );
}

export default RateEditor;
